var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 85,
    viewBox: "0 0 74 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 58.0461L10.75 58.0461C8.42936 58.0461 6.20376 57.226 4.56282 55.7662C2.92187 54.3064 2 52.3264 2 50.2619L2 9.78419C2 7.71969 2.92188 5.73976 4.56282 4.27994C6.20376 2.82012 8.42936 2 10.75 2L63.25 2.00001C65.5706 2.00001 67.7962 2.82013 69.4372 4.27994C71.0781 5.73976 72 7.7197 72 9.78419L72 50.262C72 52.3264 71.0781 54.3064 69.4372 55.7662C67.7962 57.226 65.5706 58.0461 63.25 58.0461L54.5 58.0461",
    stroke: "#9DC3EA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 39.3641L37 23.7957L19.5 39.3641M37 82.9555L37 26.9094",
    stroke: "#9DC3EA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.9f073fabaa9907d54e3719c4ff1387b9.svg";
export { ForwardRef as ReactComponent };